import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../actions/authActions';
import * as sessionActions from '../../actions/sessionActions';
import * as profileActions from '../../actions/profileActions';
import * as policyActions from '../../actions/policyActions';
import * as registrationActions from '../../actions/registrationActions';
import { push } from 'connected-react-router';
import { authSelector, sessionSelector, appSelector } from '../../selectors';
import { Container, Grid, Form, Message, Button } from 'semantic-ui-react';
import { Login, LoginAs, RegistrationComplete } from '../../components/auth';
import AddToHomeScreen from '../../components/AddToHomeScreen';

class LoginPage extends Component {
	constructor(props) {
		super(props);
		this.state = { attempt: 0, requiresEmailConfirmation: false, resendSuccess: false, error: null };
		this.linkClick = this.linkClick.bind(this);
		this.login = this.login.bind(this);
		this.onAuthenticate = this.onAuthenticate.bind(this);
		this.onLoginUpdated = this.onLoginUpdated.bind(this);
		this.onRememberMe = this.onRememberMe.bind(this);
		this.onChangeUser = this.onChangeUser.bind(this);
		this.LoginIfNeeded = this.LoginIfNeeded.bind(this);
		this.onResendEmailConfirmation = this.onResendEmailConfirmation.bind(this);
	}

	componentDidMount() {
		this.LoginIfNeeded();
	}
	componentDidUpdate() {
		this.LoginIfNeeded();
	}

	LoginIfNeeded() {
		const { auth, session } = this.props;
		const { attempt } = this.state;

		if (auth.loading) return;
		
		if (!session.authenticated && !auth.authenticated) {
			if (attempt > 3) return;

			return this.login();
		}
	}

	linkClick(e) {
		e.preventDefault();
		this.props.actions.push(e.target.pathname);
	}

	async login() {
		const { auth, actions } = this.props;
		const { attempt } = this.state;
		this.setState({ attempt: attempt + 1 });
		
		const token = localStorage.getItem('rememberMe');
		if(token || !auth.username || !auth.password) return;  //Wait for the continue

		const loginResult = await actions.logInUser(auth);

		if (!!loginResult.response.token) {
			const profileResult = await actions.getProfile();
			let isLegacy = true;
			if (auth.username) {
				if (auth.username.includes('@')) {
					if (profileResult && profileResult.response && profileResult.response.email) {
						if (auth.username.toLowerCase() === profileResult.response.email.toLowerCase()) {
							isLegacy = false;
						}
					}
				}
			} else {
				if (profileResult && profileResult.response && profileResult.response.email && profileResult.response.email.includes('@')) {
					isLegacy = false;
				}
			}
			
			if (isLegacy) {
				actions.setLegacyUserAuth(auth.username);
				return actions.push('/legacyuser');
			}

			const returnPath = localStorage.getItem('returnFromLogin');

			actions.push(returnPath || '/');
		}
	}

	async onAuthenticate() {
		try {		
			await this.login();
		} catch (error) {
			if (error.message === 'Requires Email Confirmation') {
				this.setState({ requiresEmailConfirmation: true });
			}
			throw error;
		}
	}

	async onRememberMe(e) {
		const { actions } = this.props;
		const token = localStorage.getItem('rememberMe');
		try {
			const loginResult = await actions.loginWithRememberMe(token);
			if (!loginResult.response.requiresLogin && !!loginResult.response.token) {
				actions.push('/');
			}
		} catch (error) {
			this.setState({ error: 'Your session has expired' });
			this.onChangeUser(e);
		}
	}

	onChangeUser(e) {
		e.preventDefault();
		const { actions } = this.props;
		localStorage.removeItem('rememberMe');
		actions.logOutUser();
	}

	onLoginUpdated(e, data) {
		const auth = { ...this.props.auth };
		if (data) {
			if (data.type === 'checkbox') auth[data.name] = data.checked;
		} else {
			auth[e.target.name] = e.target.value;
		}
		this.props.actions.updateUserAuth(auth);
	}

	async onResendEmailConfirmation() {
		const { auth } = this.props;
		await this.props.actions.resendConfirmationEmail(auth);
		this.setState({ resendSuccess: true });
	}

	render() {
		const { auth, app } = this.props;
		const token = localStorage.getItem('rememberMe');
		const { requiresEmailConfirmation, resendSuccess, error } = this.state;
		const login = token ? (
			<LoginAs token={token} onSubmit={this.onRememberMe} onChangeUser={this.onChangeUser} />
		) : (
			<Login onChange={this.onLoginUpdated} onSubmit={this.onAuthenticate} loading={auth.loading} error={auth.error || error}>
				<Form.Field>
					<a href='/forgot' onClick={this.linkClick}>
						Forgot Password?
					</a>
				</Form.Field>
				<Form.Field>
					<a href='/registration' onClick={this.linkClick}>
						Create Account
					</a>
				</Form.Field>
			</Login>
		);
		return (
			<div className='auth login'>
				<Container>
					<Grid columns='equal'>
						<Grid.Column width={7} only='tablet computer' />
						<Grid.Column computer={8} mobile={16} tablet={8}>
							{app.systemInfoMessage && app.systemInfoMessage.length > 0 ? (
								<Message
									warning
									content={app.systemInfoMessage.map((e, index) => (
										<div key={index}>{`${e}`}</div>
									))}
								/>
							) : null}
							{!requiresEmailConfirmation ? (
								login
							) : (
								<div>
									<RegistrationComplete resendSuccess={resendSuccess}>
										{!resendSuccess ? (
											<Button basic fluid onClick={this.onResendEmailConfirmation}>
												Resend
											</Button>
										) : null}
									</RegistrationComplete>
								</div>
							)}
						</Grid.Column>
					</Grid>
				</Container>
				<AddToHomeScreen />
			</div>
		);
	}
}

LoginPage.propTypes = {
	auth: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	app: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		auth: authSelector(state),
		session: sessionSelector(state),
		app: appSelector(state)
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(authActions, dispatch),
			...bindActionCreators(profileActions, dispatch),
			...bindActionCreators(policyActions, dispatch),
			...bindActionCreators(sessionActions, dispatch),
			...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators({ push }, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
